import styled from 'styled-components';
import Image from 'next/image';

type RatingProps = {
  rating: number;
};

function Rating({ rating }: RatingProps) {
  const stars = new Array(rating).fill(null);

  return (
    <Wrapper>
      <StarsWrapper>
        {stars.map((_, index) => (
          <Image
            width={22}
            height={21}
            alt="star"
            src="icons/star.svg"
            key={index}
          />
        ))}
      </StarsWrapper>

      <RatingValue>{rating.toFixed(1)}</RatingValue>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  height: 27px;
  width: 294px;

  margin-bottom: 20px;
`;

const StarsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const RatingValue = styled.span`
  position: relative;
  top: 2px;
  margin-left: 10px;

  font-weight: 600;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export default Rating;
